<app-header></app-header>
<div class="container-fluid bg-about-us py-24" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-5xl font-bold text-white">Enroll</p>
    <p class="pt-8 text-4xl text-center font-bold text-white">Our journey unfolds.</p>
    <p class="text-2xl text-center text-white pt-4">Streamline, Simplify, and Succeed Together</p>
  </div>
</div>

<div class="container mx-auto p-4 mt-10 md:mt-20">
  <div class="bg-white shadow-md rounded-2xl overflow-hidden">
    <div class="relative" style="padding-top: 40%;">
      <iframe class="absolute inset-0 w-full h-full" src="https://www.youtube.com/embed/ffqhigwoass?si=gMd-wElk7zRBMBb2"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about1.png" alt="Image" class="max-w-full">
      </div>
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Our Company Overview</p>
        <p class="text-lg md:text-xl text-justify text-zinc-500">At Volmint Technologies, we stand at the forefront of innovation in education
          technology with
          a singular focus: empowering institutions to streamline and elevate their admission processes effortlessly.
          Our flagship product, "Enroll," represents the pinnacle of our dedication to efficiency and user-centric
          design. Founded on a commitment to excellence, Volmint has consistently delivered cutting-edge solutions
          tailored to meet the dynamic needs of ever-evolving businesses worldwide. Our team of visionary developers and
          industry experts collaborates tirelessly to ensure that "Enroll" not only meets but exceeds the expectations
          of our clients to manage the admissions flawlessly.</p>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Charting the Future: Our Vision and Mission</p>
        <p class="text-lg md:text-xl text-justify text-zinc-500">Pioneering the future of admissions management by providing intuitive solutions that empower
          educational institutions and candidates worldwide.
          Our mission is to revolutionize the process of admissions with cutting-edge technology, ensuring institutions
          and applicants experience a streamlined journey from start to finish</p>
        <div class="w-full flex justify-center md:justify-start">
        <button
          class="mt-12 flex items-center px-6 py-3 text-xl bg-[#6752A9] text-white rounded-lg btn-pulse transition whitespace-nowrap duration-200"
          (click)="goTo('auth/register')">
          Experience it Now
          <img src="./assets/images/tilted-arrow.png" width="34" height="27" class="ml-2" alt="Arrow Icon">
        </button>
        </div>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about2.png" alt="Image" class="max-w-full">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about3.png" alt="Image" class="max-w-full">
      </div>
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Why Do You Need Enroll’s AMS</p>
        <p class="text-lg md:text-xl text-zinc-500 text-justify mb-16">Enroll’s AMS is essential for smooth organisational operation, offering numerous benefits and
          features that streamline the admission and enrollment process efficiently including Centralize Student
          Inquiries Seamlessly, Monitor and Enhance Student Journey, and Empowering Connections.</p>
        <div class="w-full flex justify-center md:justify-start">
        <button
          class="mt-4 md:mt-12 flex items-center px-6 py-3 text-xl bg-[#6752A9] text-white rounded-lg btn-pulse transition whitespace-nowrap duration-200"
          (click)="goTo('auth/register')">
          Sign up now
          <img src="./assets/images/tilted-arrow.png" width="34" height="27" class="ml-2" alt="Arrow Icon">
        </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 bg-about4 rounded-none" [style.font-family]="'var(--vex-font)'">
  <div class="container py-12 rounded-none">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:mt-24 pt-4 md:pt-12 p-4 md:w-1/2">
        <p class="text-2xl md:text-4xl mb-2 font-semibold text-center md:text-start">Multi-University Mastery: </p>
        <p class="text-2xl md:text-4xl mb-2 font-semibold text-center md:text-start">Simplify Admission Across </p>
        <p class="text-2xl md:text-4xl mb-2 font-semibold text-center md:text-start">Institutions</p>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about4.png" alt="Image" class="max-w-full">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Lead the Way: Effective Lead Management From Various Platforms</p>
        <p class="text-lg md:text-xl text-zinc-500 text-justify">Enroll empowers institutions with robust lead management tools, ensuring efficient tracking,
          nurturing, and conversion of prospects into successful applicants.</p>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about5.png" alt="Image" class="max-w-full">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about6.png" alt="Image" class="max-w-full">
      </div>
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Clear Paths, Bright Futures: Enhancing Communication and Notifications</p>
        <p class="text-lg md:text-xl text-justify text-zinc-500">Enroll facilitates seamless communication and timely notifications, ensuring all stakeholders
          stay informed and engaged throughout the admission process, fostering clarity and efficiency.</p>
        <div class="w-full flex justify-center md:justify-start">
        <button
          class="mt-12 flex items-center px-6 py-3 text-xl bg-[#6752A9] text-white rounded-lg btn-pulse transition whitespace-nowrap duration-200"
          (click)="goTo('auth/register')">
          Enroll Today
          <img src="./assets/images/tilted-arrow.png" width="34" height="27" class="ml-2" alt="Arrow Icon">
        </button>
      </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 bg-consultancy py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2  ">
      <div class="">
        <div class="w-full flex justify-center md:justify-start">
        <img src="assets/images/Chat.png" alt="Image" class="py-5"/>
        </div>
        <h1 class="font-inter text-white text-3xl font-medium text-center md:text-start">Get a free consultation from our expert</h1>
        <h1 class="font-inter text-white text-5xl font-bold text-center md:text-start"> Right Now!</h1>
        <p class="text-white text-xl pt-3 pb-20 text-center md:text-start">Discover what's possible with Volmint Technologies. Let's Innovate, Grow, and Succeed together.</p>
      </div>
      <div class="md:relative lg:relative flex justify-end">
        <div class="bg-white px-8 mt-2 md:mt-20 rounded-lg w-full max-w-lg md:absolute lg:absolute">
          <form class="p-6 flex flex-col gap-4" [formGroup]="addEnquiryForm" (ngSubmit)="submit()">
            <p class="text-center text-2xl font-semibold text-maroon mb-4">Request For a Free Consultation & see the difference!</p>
            <div class="flex flex-col gap-4">
              <div class="relative pb-2">
                <label for="name" class="block text-lg font-medium text-gray-700 mb-1">Name</label>
                <input id="name" formControlName="name" type="text" placeholder="John Doe"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('name').hasError('required')">
                  Name field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="email" class="block text-lg font-medium text-gray-700 mb-1">Email</label>
                <input id="email" formControlName="email" type="email" placeholder="abctestmail@gmail.com"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('required')">
                  Email field is required
                </small>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('pattern')">
                  Invalid email format
                </small>
              </div>
              <div class="relative pb-2">
                <label for="contact" class="block text-lg font-medium text-gray-700 mb-1">Phone Number</label>
                <input id="contact" formControlName="contact" type="tel" placeholder="+91-7836899999"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('contact').hasError('required')">
                  Contact field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="subject" class="block text-lg font-medium text-gray-700 mb-1">Subject</label>
                <input id="subject" formControlName="subject" type="text" placeholder="Subject"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('subject').hasError('required')">
                  Subject field is required
                </small>
              </div>
              <button type="submit"
                      class="table-header-color text-white py-3 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out">
                Get a Call Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-72 bg-faq py-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-2xl md:text-4xl font-semibold">
      Frequently Asked Questions
    </p>
    <div class="flex flex-col md:flex-row justify-between items-center gap-8 pt-8">
      <div class="flex-1 flex-shrink-0">
        <img src="/assets/images/features-images/faq4.jpeg" alt="FAQ Image" class="w-full md:h-96 rounded-2xl"/>
      </div>
      <div class="flex-1 flex flex-col">
        <div class="flex-1 flex flex-col md:max-w-xl px-1 md:px-0">
          <mat-accordion class="p-2 flex-1">
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header class="flex items-center">
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    What sets Volmint Technologies apart in the realm of educational technology?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 md:pt-0 md:mt-0 text-justify text-zinc-500">
                At Volmint Technologies, we differentiate ourselves through innovation and practicality. Our commitment to
                advancing educational management solutions is reflected in "Enroll," our state-of-the-art Admission
                Management Software. We harness cutting-edge technology to simplify and enhance the admission process for
                institutions worldwide, ensuring seamless integration and intuitive user experiences.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    What achievements has Volmint Technologies attained in the field of educational software development?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Volmint Technologies has earned recognition for its pioneering solutions in educational software. We are
                proud of our track record in delivering robust, scalable, and user-friendly software solutions that empower
                institutions to achieve operational excellence and student satisfaction.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    How does Volmint Technologies support institutions in adopting and utilizing "Enroll"?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                At Volmint Technologies, we prioritize client success and satisfaction. We offer comprehensive support and
                training programs tailored to the specific needs of each institution. Our dedicated team collaborates
                closely with clients to ensure a seamless transition to "Enroll," providing ongoing assistance and updates
                to optimize performance and maximize efficiency.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                     What is Volmint Technologies' vision for the future of educational management software?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Our vision at Volmint Technologies is to continue innovating and expanding the capabilities of "Enroll" and
                other educational solutions. We aim to set new benchmarks in efficiency, reliability, and user experience,
                anticipating and adapting to the evolving needs of academic institutions globally. We strive to empower
                institutions to thrive in a digital age through relentless innovation and a deep understanding of
                educational dynamics.
              </p>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="above-footer py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>



